module.exports = __webpack_public_path__ + "audio-af52841404d3.m4a";